//inserito if per controllo su banca ispbih altrimenti questo js manda in errore i date picker sulle altre banche
if ($("html").attr("data-bank") == "ISPBIH") { 
 // mesi archivio
	var interval;
    $(document).ready(function() {
        interval = setTimeout(changeMonthOfMediaReleaseISPBIH, 1000);
        setTimeout(function () {
        	$(".ispbih .com15__filterInner").on( "click", function() {
                interval = setTimeout(changeMonthOfMediaReleaseISPBIH, 100);
            });
		}, 1000)
    });
    
    function changeMonthOfMediaReleaseISPBIH() {
        var divs = document.querySelectorAll('.ispbih .aboutCom-pressAndNews select[name="filterByMonth"] option span');
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){										   
        	divs = Array.prototype.slice.call(divs);
        }
        var lang = $('html')[0].getAttribute('lang');
        if (divs.length > 0) {
            divs.forEach(function(entry) {
                var meseC = entry.innerText;
                if(lang == "bs"){
                	if (meseC == "M01") {
                        newmeseL = "Januar";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M02") {
                        newmeseL = "Februar";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M03") {
                        newmeseL = "Mart";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M04") {
                        newmeseL = "April";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M05") {
                        newmeseL = "Maj";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M06") {
                        newmeseL = "Juni";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M07") {
                        newmeseL = "Juli";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M08") {
                        newmeseL = "August";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M09") {
                        newmeseL = "Septembar";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M10") {
                        newmeseL = "Oktobar";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M11") {
                        newmeseL = "Novembar";
                        entry.innerText = newmeseL;
                    } else if (meseC == "M12") {
                        newmeseL = "Decembar";
                        entry.innerText = newmeseL;
                    }
                }
            });
        }
    }

}